import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|Eligibilities|';
const sharedProperties: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.ExamAuthorization,
	portal: 'SP',
};

type LocNameStart = 'SPEligibilityGrantDialog';
export type SPEligibilityGrantDialogLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}FieldLabelActiveDate`
	| `${LocNameStart}FieldLabelExpireDate`
	| `${LocNameStart}FieldLabelExam`
	| `${LocNameStart}FieldErrorActiveDateRequired`
	| `${LocNameStart}FieldErrorActiveDateInvalid`
	| `${LocNameStart}FieldErrorExpireDateInvalid`
	| `${LocNameStart}FieldErrorExamRequired`
	| `${LocNameStart}FieldErrorExamInvalid`
	| `${LocNameStart}ButtonGrantCancel`
	| `${LocNameStart}ButtonGrant`
	| `${LocNameStart}FieldLabelSendOkDate`
	| `${LocNameStart}FieldErrorSendOKDateInvalid`;

export const spEligibilityGrantDialogLocs: LocDefs<SPEligibilityGrantDialogLocNames> = {
	SPEligibilityGrantDialogTitle: {
		defaultValue: 'Grant an Eligibility',
		description: 'Title for the grant eligiblity dialog',
		displayPath: `${dpRoot}Title`,
		displayType: 'Title',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Title.Grant',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Label for the active date field',
		displayPath: `${dpRoot}Field Label Active Date`,
		displayType: 'Label',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.ActiveDate',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldLabelExpireDate: {
		defaultValue: 'Expiration Date',
		description: 'Label for the expiration date field',
		displayPath: `${dpRoot}Field Label Expire Date`,
		displayType: 'Label',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.ExpireDate',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldLabelExam: {
		defaultValue: 'Exam',
		description: 'Label for the exam selection field',
		displayPath: `${dpRoot}Field Label Exam`,
		displayType: 'Label',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.Exam',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorActiveDateRequired: {
		defaultValue: 'The active date is required',
		description: 'Error when the active date is not supplied',
		displayPath: `${dpRoot}Field Error Active Date Required`,
		displayType: 'Error',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ActiveDateRequired',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorActiveDateInvalid: {
		defaultValue: 'The active date must be today or later and before the expiration date',
		description: 'Error message when active date is invalid',
		displayPath: `${dpRoot}Field Error Active Date Invalid`,
		displayType: 'Error',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ActiveDateInvalid',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorExpireDateInvalid: {
		defaultValue: "Expiration date must be after the active date and today's date",
		description: 'Error message when expiration date is invalid',
		displayPath: `${dpRoot}Field Error Expire Date Invalid`,
		displayType: 'Error',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ExpireDateInvalid',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorExamRequired: {
		defaultValue: 'Exam is required',
		description: 'Error when the exam is not selected',
		displayPath: `${dpRoot}Field Error Exam Required`,
		displayType: 'Error',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ExamRequired',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorExamInvalid: {
		defaultValue: 'You must choose an option from the list',
		description: 'Error when the exam is invalid',
		displayPath: `${dpRoot}Field Error Exam Invalid`,
		displayType: 'Error',
		htmlAllowed: false,
		...sharedProperties,
	},
	SPEligibilityGrantDialogButtonGrantCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button on eligibility grant',
		displayPath: `${dpRoot}Button Grant Cancel`,
		displayType: 'Button',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.GrantCancel',
		...sharedProperties,
	},
	SPEligibilityGrantDialogButtonGrant: {
		defaultValue: 'Grant Eligibility',
		description: 'Button to confirm granting an eligibility',
		displayPath: `${dpRoot}Button Grant`,
		displayType: 'Button',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.Grant',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldLabelSendOkDate: {
		defaultValue: 'Send OK Date',
		description: 'Label for the send OK date field',
		displayPath: `${dpRoot}Field Label Send OK Date`,
		displayType: 'Label',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.SendOkDate',
		...sharedProperties,
	},
	SPEligibilityGrantDialogFieldErrorSendOKDateInvalid: {
		defaultValue: 'Send OK date must be before the active date',
		description: 'Error when the send OK date is invalid',
		displayPath: `${dpRoot}Field Error Send OK Date Invalid`,
		displayType: 'Error',
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.SendOKDateInvalid',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPEligibilityGrantDialogLocNames>(spEligibilityGrantDialogLocs);
